<script setup>
import {ref} from 'vue'

const services = ref([
  {
    id: 'repair',
    title: '慧维修',
    description: '设备故障诊断与修复服务',
    icon: 'tool',
    iconColor: 'rgb(24, 144, 255)',
    features: ['智能故障诊断', '专业维修技术', '原厂配件保障', '质量保证承诺'],
    buttonText: '立即报修'
  },
  {
    id: 'rental',
    title: '慧租赁',
    description: '智能设备短期租赁服务',
    icon: 'shopping',
    iconColor: 'rgb(82, 196, 26)',
    features: ['灵活租赁方案', '设备质量保证', '快速配送服务', '技术支持保障'],
    buttonText: '立即租赁'
  },
  {
    id: 'management',
    title: '慧管理',
    description: '企业设备全生命周期管理',
    icon: 'setting',
    iconColor: 'rgb(250, 140, 22)',
    features: ['设备档案管理', '维护计划制定', '成本控制分析', '效率优化建议'],
    buttonText: '管理咨询'
  },
  {
    id: 'maintenance',
    title: '慧保养',
    description: '定期维护与预防性保养服务',
    icon: 'heart',
    iconColor: 'rgb(235, 47, 150)',
    features: ['定期保养计划', '预防性维护', '性能检测', '延长设备寿命'],
    buttonText: '预约保养'
  }
])

const advantages = ref([
  {value: '7×24', label: '全天候服务', description: '随时随地为您提供专业服务', color: 'rgb(24, 144, 255)'},
  {value: '300+', label: '服务网点', description: '覆盖全国主要城市，就近服务', color: 'rgb(82, 196, 26)'},
  {value: '99%', label: '满意度', description: '用户满意度持续保持高水平', color: 'rgb(250, 140, 22)'}
])
</script>

<template>
  <div class="container">
    <div class="content-wrapper">
      <div class="page-header">
        <h1>全部服务</h1>
        <div class="page-subtitle">智维驿为您提供全方位的智能设备服务解决方案</div>
      </div>
      <div class="store-card">
        <div class="store-card-header">
          <div class="store-card-title">
            <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor"
                 class="store-icon">
              <path
                  d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"></path>
            </svg>
            <span>查看服务网点</span>
          </div>
        </div>
        <div class="store-card-body">
          <div class="store-search-row">
            <div class="store-search-col">
              <div class="store-search-input-group">
                <input placeholder="点击按钮查看服务网点信息" type="search" class="store-search-input">
                <button type="button" class="store-search-btn">
                  <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
                    <path
                        d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path>
                  </svg>
                  <span>查看服务网点</span>
                </button>
              </div>
            </div>
            <div class="store-search-col-right">
              <button type="button" class="store-show-btn">
                <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
                  <path
                      d="M854.6 289.1a362.49 362.49 0 00-79.9-115.7 370.83 370.83 0 00-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 00169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0022.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z"></path>
                </svg>
                <span>显示服务网点地址</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="service-row">
        <div v-for="service in services" :key="service.id" class="service-col">
          <div class="service-card">
            <div class="service-card-body">
              <div class="service-icon" :style="{ color: service.iconColor }">
                <!-- tool 图标 -->
                <svg v-if="service.icon === 'tool'" viewBox="64 64 896 896" focusable="false" width="1em" height="1em"
                     fill="currentColor">
                  <path
                      d="M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 01144-53.5L537 318.9a32.05 32.05 0 000 45.3l124.5 124.5a32.05 32.05 0 0045.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z"></path>
                </svg>
                <!-- shopping 图标 -->
                <svg v-else-if="service.icon === 'shopping'" viewBox="64 64 896 896" focusable="false" width="1em"
                     height="1em" fill="currentColor">
                  <path
                      d="M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z"></path>
                </svg>
                <!-- setting 图标 -->
                <svg v-else-if="service.icon === 'setting'" viewBox="64 64 896 896" focusable="false" width="1em"
                     height="1em" fill="currentColor">
                  <path
                      d="M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 009.3-35.2l-.9-2.6a443.74 443.74 0 00-79.7-137.9l-1.8-2.1a32.12 32.12 0 00-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 00-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 00-25.8 25.7l-15.8 85.4a351.86 351.86 0 00-99 57.4l-81.9-29.1a32 32 0 00-35.1 9.5l-1.8 2.1a446.02 446.02 0 00-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 00-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0035.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0025.8 25.7l2.7.5a449.4 449.4 0 00159 0l2.7-.5a32.05 32.05 0 0025.8-25.7l15.7-85a350 350 0 0099.7-57.6l81.3 28.9a32 32 0 0035.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 01-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 01-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 01512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 01400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 01624 502c0 29.9-11.7 58-32.8 79.2z"></path>
                </svg>
                <!-- heart 图标 -->
                <svg v-else-if="service.icon === 'heart'" viewBox="64 64 896 896" focusable="false" width="1em"
                     height="1em" fill="currentColor">
                  <path
                      d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                </svg>
              </div>
              <h3 class="service-title">{{ service.title }}</h3>
              <div class="service-description">{{ service.description }}</div>
              <ul class="service-features">
                <li v-for="(feature, index) in service.features" :key="index" class="service-feature-item">
                  <span class="feature-check">✓</span>{{ feature }}
                </li>
              </ul>
              <button type="button" class="service-btn">
                <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
                  <path
                      d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 000-48.4z"></path>
                </svg>
                <span>{{ service.buttonText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="advantage-card">
        <div class="advantage-card-body">
          <h2 class="advantage-title">为什么选择智维驿？</h2>
          <div class="advantage-row">
            <div v-for="(advantage, index) in advantages" :key="index" class="advantage-col">
              <div class="advantage-item">
                <div class="advantage-value" :style="{ color: advantage.color }">{{ advantage.value }}</div>
                <h4 class="advantage-label">{{ advantage.label }}</h4>
                <div class="advantage-description">{{ advantage.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
}

.content-wrapper {
  margin: auto;
  width: 60rem;
  padding: 1.5rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.page-subtitle {
  font-size: 1rem;
  color: #666;
}

.store-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.store-card-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e8e8e8;
}

.store-card-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

.store-icon {
  font-size: 1.25rem;
  color: #1890ff;
}

.store-card-body {
  padding: 1.5rem;
}

.store-search-row {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.store-search-col {
  flex: 1;
}

.store-search-input-group {
  display: flex;
  gap: 0.5rem;
}

.store-search-input {
  flex: 1;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-size: 0.875rem;
  outline: none;
}

.store-search-input:focus {
  border-color: #1890ff;
}

.store-search-btn {
  padding: 0.5rem 1rem;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  transition: background 0.2s;
}

.store-search-btn:hover {
  background: #40a9ff;
}

.store-search-btn svg {
  font-size: 0.875rem;
}

.store-search-col-right {
  flex-shrink: 0;
}

.store-show-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  color: #1890ff;
  border: 1px solid #1890ff;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  transition: all 0.2s;
}

.store-show-btn:hover {
  background: #e6f7ff;
}

.store-show-btn svg {
  font-size: 0.875rem;
}

.service-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -1rem;
  margin-right: -1rem;
  row-gap: 2rem;
}

.service-col {
  flex: 0 0 25%;
  padding-left: 1rem;
  padding-right: 1rem;
}

.service-card {
  height: 100%;
  text-align: center;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  transition: all 0.3s;
}

.service-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.service-card-body {
  padding: 2rem 1.5rem;
}

.service-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.service-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  color: #333;
}

.service-description {
  color: #666;
  font-size: 0.875rem;
  height: 3rem;
}

.service-features {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
  text-align: left;
}

.service-feature-item {
  margin-bottom: 0.5rem;
  padding-left: 1.25rem;
  position: relative;
  font-size: 0.875rem;
  color: #666;
}

.feature-check {
  position: absolute;
  left: 0;
  color: rgb(82, 196, 26);
}

.service-btn {
  width: 100%;
  padding: 0.75rem 1rem;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: background 0.2s;
}

.service-btn:hover {
  background: #40a9ff;
}

.service-btn svg {
  font-size: 0.875rem;
}

.advantage-card {
  margin-top: 3rem;
  text-align: center;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
}

.advantage-card-body {
  padding: 2rem;
}

.advantage-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 2rem 0;
  color: #333;
}

.advantage-row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  row-gap: 1.5rem;
  margin-top: 2rem;
}

.advantage-col {
  flex: 0 0 33.333%;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.advantage-item {
  text-align: center;
}

.advantage-value {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.advantage-label {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.advantage-description {
  font-size: 0.875rem;
  color: #666;
}
</style>